import axiosInstance from "./axiosConfig";
import { AddAdvertiser, Advertiser } from '../types/advertiser';

export const getAdvertisers = async () => {
    const response = await axiosInstance.get<Advertiser[]>('/advertiser');
    return response?.data;
};

export const createAdvertiser = async (advertiser: AddAdvertiser) => {
    const response = await axiosInstance.post<Advertiser>('/advertiser', advertiser);
    return response?.data;
}

export const updateAdvertiser = async (advertiser: Advertiser) => {
    const response = await axiosInstance.patch<Advertiser>(`/advertiser/${advertiser.id}`, advertiser);
    return response?.data;
}